


















import { defineComponent, ref } from "@vue/composition-api";
import { RecommendedUser } from "@scrile/api-provider/dist/api/RecommendedUserProvider";
import providers from "@/lib/api";
import CustomScroll from "@/components/CustomScroll";
import SuggestedCreatorsItem from "./components/SuggestedCreatorsItem";

export default defineComponent({
  name: "SuggestedCreators",
  components: { SuggestedCreatorsItem, CustomScroll },
  props: {
    userIds: { type: Array as () => string[], required: true },
  },
  setup(props) {
    const recommendedUsers = ref<RecommendedUser[]>([]);
    const followingIdsList = ref<string[]>([]);

    const getCreators = async () => {
      const response = await providers.RecommendedUserProvider.search({
        data: {
          size: 999,
          sort: "RANDOM",
          profileUserIds: props.userIds,
        },
      });
      recommendedUsers.value = response.result;
      if (!recommendedUsers.value.length) return;
      const followingsResponse = await providers.FollowingsProvider.searchFollowings({
        ids: recommendedUsers.value.map(i => i.user.id),
      });
      followingIdsList.value = followingIdsList.value.concat(followingsResponse.map(i => i.userId));
    };

    const getFollowing = (userId: string): boolean => !!followingIdsList.value.find(id => id === userId);

    getCreators();

    return { recommendedUsers, followingIdsList, getFollowing };
  },
});
